import PosteForm from "@features/creation/postes/components/PosteForm";
import { requirePermission } from "@lib/permissions/guards";
import { PERMISSIONS } from "@lib/permissions/permissions.generated";
import { createFileRoute } from "@tanstack/react-router";
import { PlusCircle } from "lucide-react";

export const Route = createFileRoute("/_app/creation/postes/create")({
  loader: requirePermission(PERMISSIONS.CREATION.POSTES.CREATE),
  staticData: {
    title: "Nouveau poste",
    icon: PlusCircle,
    permission: PERMISSIONS.CREATION.POSTES.CREATE,
    section: "Creation",
    showInBreadcrumb: true,
  },
  component: CreatePostePage,
});

function CreatePostePage() {
  return (
    <div className="max-w-3xl mx-auto">
      <div className="mb-6">
        <h1 className="text-2xl font-bold">Nouveau poste de travail</h1>
        <p className="text-sm text-base-content/60">
          Créer un nouveau poste de travail
        </p>
      </div>
      <PosteForm />
    </div>
  );
}
